import React from "react";
import styles from "./styles.less";

const Divider = () => <hr className={styles.divider} />;

export default Divider;



// WEBPACK FOOTER //
// ./src/components/Cart/Divider/Divider.js